import React from 'react';
import RewardReview from '@/containers/Rewards/RewardReview/RewardReview';
import {RewardFlowWrapper} from '@/containers/Rewards/common/components';
import {useRewardsView} from '@/containers/Rewards/common/hooks';
import {
  DEFAULT_VALUES,
  SECTION_TITLES
} from '@/containers/Rewards/RewardReview/components/common/ReviewConstants';

const {REWARD_REVIEW} = SECTION_TITLES.DISPLAY;

/**
 * ViewReward component - View flow only
 * Handles read-only viewing of existing rewards
 */
const ViewReward = () => {
  const {formData, currentStep, isLoading} = useRewardsView();

  const name = formData?.name || DEFAULT_VALUES.FALLBACK;

  return (
    <RewardFlowWrapper
      mode='view'
      title={name}
      breadcrumbLabel={REWARD_REVIEW}
      showProgressIndicator={false}
      showFooter={false}
      isLoading={isLoading}
      formErrors={false}
      currentStep={currentStep}
      stepTitles={[]}
      isEditDisabled={true}
      isPublishDisabled={true}
      showDownload={true}
      updatedDate={formData?.updatedAtDisplay}
      isNameValid={true}>
      <RewardReview mode='view' />
    </RewardFlowWrapper>
  );
};

export default ViewReward;
